import { useMutation, useQueryClient } from "@tanstack/react-query";
import { completeTaskById } from "../../../../../lib/api/resources/tasks";
import { message } from "antd";

// Handles completing a task by id, invalidating the tasks list and single task cache if present
export const useCompleteTaskMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<null, Error, string>({
    mutationFn: (id: string) => completeTaskById(id),
    onSuccess: (_data, id) => {
      message.success("Taak is afgevinkt");
      queryClient.invalidateQueries({ queryKey: ["tasks"] });
      queryClient.invalidateQueries({ queryKey: ["task", id] });
    },
    onError: () => {
      message.error("Afvinken mislukt");
    },
  });
};
